import img from "../../../../groupe_pages/PMT/img/img_v2/SLIDE_oxygene-experience-spa-casablanca-2.jpg";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";


const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);


const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);


export default function UsStretchPage() {


  // ✅ HOOK DOIT ÊTRE ICI
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);
  return (
    <div className="us-page">
      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right"className="us-badge" ><h3 ><span className="subtitle-us">US</span> <b>STRETCH</b></h3></div>
          <h1 data-aos="fade-up">Plafonds & Murs Tendus PVC Haute Performance</h1>
          <p data-aos="fade-up">
            Solution professionnelle en toile PVC tendue pour plafonds et murs.
            Finition parfaite, installation rapide et intégration lumineuse avancée.
            Idéal pour projets résidentiels, commerciaux et techniques.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">Demander un devis</a>
            <a     href="/pdf/fiche-technique1.pdf"  download className="btn-outline">Télécharger la fiche technique</a>

          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img
            src={img}
            alt="US Stretch plafond tendu"
          />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle data-aos="fade-up"
          small="Présentation"
          big="Qu’est-ce que la solution US STRETCH ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US STRETCH est un système de revêtement en toile PVC tendue monté
            sur profilés techniques. Il permet d’obtenir une surface lisse,
            décorative ou lumineuse sans travaux lourds ni salissures.
          </p>

          <p data-aos="fade-up">
            Grâce à une large gamme de finitions, textures et performances,
            cette solution s’adapte à tous les environnements : habitat,
            commerce, hôtellerie, santé et architecture technique.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle data-aos="fade-up" small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature data-aos="fade-up"
            icon="⚡"
            title="Pose rapide"
            text="Installation propre en quelques heures sans démolition."
          />
          <Feature data-aos="fade-up"
            icon="🎨"
            title="Adaptation totale"
            text="Couleurs, impressions HD, textures et effets spéciaux."
          />
          <Feature data-aos="fade-up"
            icon="💧"
            title="Hydrofuge"
            text="Résistant à l’humidité, adapté piscines et spas."
          />
          <Feature data-aos="fade-up"
            icon="🔥"
            title="Résistant au feu"
            text="Classement B-s1,d0 selon normes techniques."
          />
          <Feature data-aos="fade-up"
            icon="💡"
            title="Compatible éclairage"
            text="LED, rétro-éclairage, spots et lignes lumineuses."
          />
          <Feature data-aos="fade-up"
            icon="🛠️"
            title="Maintenance facile"
            text="Lavable, démontable et remplaçable."
          />
        </div>
      </section>

      {/* FINITIONS */}
      <section className="us-section">
        <SectionTitle data-aos="fade-up" small="Design" big="Finitions disponibles" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Brillant miroir",
            "Mat",
            "Satiné",
            "Texturé",
            "Impression HD",
            "Rétro-éclairé",
            "Translucide",
            "Ciel étoilé",
            "Laqué coloré",
          ].map((t) => (
            <span key={t}>{t}</span>
          ))}
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section us-gray">
        <SectionTitle data-aos="fade-up" small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Toile PVC haute résistance</li>
          <li>Profilés aluminium techniques</li>
          <li>Tension thermique contrôlée</li>
          <li>Intégration capteurs & ventilation</li>
          <li>Compatible systèmes acoustiques</li>
          <li>Traitement antibactérien disponible</li>
          <li>Résistance chlore & condensation</li>
        </ul>
      </section>

      {/* PROCESS */}
      <section  className="us-section">
        <SectionTitle data-aos="fade-up" small="Méthode" big="Processus d’installation" />

        <div data-aos="fade-up" className="us-steps">
          {[
            "Prise de mesures",
            "Fabrication sur mesure",
            "Pose des profilés",
            "Mise en chauffe",
            "Tension de la toile",
            "Intégration éclairage",
            "Contrôle final",
          ].map((s, i) => (
            <div key={s} className="us-step">
              <div className="us-step-num">{i + 1}</div>
              <p>{s}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Prêt à intégrer US STRETCH dans votre projet ?</h2>
        <p>Contactez notre équipe technique pour une étude personnalisée.</p><br/>
        <a href="/contact" className="btn-primarya">Contact nos</a>
      </section>
    </div>
  );
}